import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ensureFreshBundleBeforeRender } from "@hooks/useAppVersionCheck";
import { loadMcmConfiguration } from "@services/mcmConfiguration";
import { getApiOrigin } from "@utils/apiOrigin";
import {
  assignApiBaseUrl,
  installServiceWorkerCleanup,
  maybeInstallCoverageHarness,
} from "./bootstrapGuards";

installServiceWorkerCleanup(window, navigator);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

async function bootstrap() {
  await ensureFreshBundleBeforeRender();
  // loadMcmConfiguration swallows its own errors; never rethrows.
  await loadMcmConfiguration();

  assignApiBaseUrl(window, getApiOrigin());

  await maybeInstallCoverageHarness(process.env.REACT_APP_COVERAGE_HARNESS, () =>
    import("./coverage/browserCoverageHarness")
  );

  const { default: App } = await import("./App");
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

void bootstrap();
reportWebVitals();
